import React, { useEffect, useState } from 'react';
import LoadingIndicator from '../LoadingIndicator';
import './pdfviewer.scss';


function DocViewer({ url }) {

    const [isLoading, setIsLoading] = useState(true);
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState("");
    const [reload, setReload] = useState(false);

    useEffect(() => {
        if (isLoading && !loaded) {
            const failTimeout = setTimeout(() => {
                // setError("Parece que no está funcionado, cierra este visor y vuélvelo a abrir");
                setReload(true);
                setTimeout(() => {
                    setReload(false);
                }, 1);
            }, 5000);
            return () => {
                clearTimeout(failTimeout);
            };
        } else {
            setError("");
        }
    }, [isLoading, loaded, reload]);


    const iframeUrl = `https://docs.google.com/gview?url=${encodeURIComponent(url)}&embedded=true`;

    return (
        <>
            { !reload &&
                <>
                    {isLoading && (
                        <div className="flex flex-col justify-center items-center w-full h-full">
                            { !loaded &&
                                <LoadingIndicator size={50} color="var(--color-primary-dark)" loading={isLoading} />
                            }
                            {/* <div className="mt-5 mb-2">Cargando documento...</div> */}
                            {/* {setFailTimeout(isLoading)} */}
                            <div className="text-xs">{error}</div>
                        </div>
                    )}
                    <iframe
                        title={"Documento"}
                        onLoad={() => {
                            setIsLoading(false);
                            setLoaded(true);
                        }}
                        src={iframeUrl}
                        className="w-full h-full"
                        style={{ display: isLoading ? "none" : "block" }}
                    ></iframe>
                </>
            }
        </>
    );

}


// eslint-disable-next-line no-func-assign
export default DocViewer = React.memo(DocViewer);